var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRookLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 162.44,
    height: 30.168,
    viewBox: "0 0 162.44 30.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle_1255",
    "data-name": "Rectangle 1255",
    width: 40.332,
    height: 30.168,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group_18507",
    "data-name": "Group 18507",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group_1148",
    "data-name": "Group 1148",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_12164",
    "data-name": "Path 12164",
    d: "M0,23.4,20.166,31.22,40.333,23.4,20.166,15.578Z",
    transform: "translate(0 -1.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_12165",
    "data-name": "Path 12165",
    d: "M20.166,0,0,7.821l20.166,7.82,20.167-7.82Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group_1147",
    "data-name": "Group 1147",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group_1146",
    "data-name": "Group 1146",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_12166",
    "data-name": "Path 12166",
    d: "M26.383,21.581v1.251A12.145,12.145,0,0,1,20.5,24.206a11.884,11.884,0,0,1-5.928-1.374V21.581a17.621,17.621,0,0,0,2.2-1.977c.356-2.336.7-4.674,1.018-7.015.126-.925.265-2.786.265-2.786S16.7,8.268,16.7,8.22c-.013-1.235-.011-3.883-.011-3.883h1.483v1.6H19.35v-1.6h2.295v1.6H22.8l.011-1.6h1.581l0,4.057L22.921,9.785S23.8,16.753,24.2,19.7a23.093,23.093,0,0,0,2.185,1.883",
    transform: "translate(-0.491 -0.146)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path_247811",
    "data-name": "Path 247811",
    d: "M4.24-4.56V0H1.48V-13.6H6.76q4.8,0,4.8,4.48a4.3,4.3,0,0,1-2,3.92L11.5,0H8.48L6.9-4.56ZM6.8-6.92a1.757,1.757,0,0,0,1.46-.6A2.454,2.454,0,0,0,8.74-9.1a2.278,2.278,0,0,0-.51-1.56,1.853,1.853,0,0,0-1.47-.58H4.24v4.32ZM17.21-3.21a2.309,2.309,0,0,0,2.21,1.05,2.309,2.309,0,0,0,2.21-1.05,7.649,7.649,0,0,0,.59-3.52,8.009,8.009,0,0,0-.6-3.59,2.27,2.27,0,0,0-2.2-1.12,2.27,2.27,0,0,0-2.2,1.12,8.009,8.009,0,0,0-.6,3.59A7.649,7.649,0,0,0,17.21-3.21Zm6.58,1.76Q22.52.24,19.42.24T15.05-1.45q-1.27-1.69-1.27-5.29a9.136,9.136,0,0,1,1.27-5.35q1.27-1.75,4.37-1.75t4.37,1.75a9.136,9.136,0,0,1,1.27,5.35Q25.06-3.14,23.79-1.45Zm6.96-1.76a2.309,2.309,0,0,0,2.21,1.05,2.309,2.309,0,0,0,2.21-1.05,7.649,7.649,0,0,0,.59-3.52,8.009,8.009,0,0,0-.6-3.59,2.27,2.27,0,0,0-2.2-1.12,2.27,2.27,0,0,0-2.2,1.12,8.009,8.009,0,0,0-.6,3.59A7.649,7.649,0,0,0,30.75-3.21Zm6.58,1.76Q36.06.24,32.96.24T28.59-1.45q-1.27-1.69-1.27-5.29a9.136,9.136,0,0,1,1.27-5.35q1.27-1.75,4.37-1.75t4.37,1.75A9.136,9.136,0,0,1,38.6-6.74Q38.6-3.14,37.33-1.45ZM44.22,0H41.46V-13.6h2.76v5.98l1.84-.2L48.3-13.6h3.14L48.48-6.78,51.52,0H48.34L46.06-5.42l-1.84.2Zm23.3,0V-6.26H60.48V0H58.94V-13.84h1.54v6.2h7.04v-6.2h1.52V0Zm6.44-6.86a8.889,8.889,0,0,0,.8,4.37q.8,1.33,3.09,1.33t3.08-1.3a8.852,8.852,0,0,0,.79-4.36,9.188,9.188,0,0,0-.82-4.46,3.252,3.252,0,0,0-3.07-1.4,3.236,3.236,0,0,0-3.06,1.39A9.168,9.168,0,0,0,73.96-6.86Zm9.36.04q0,3.7-1.18,5.36T77.85.2q-3.11,0-4.29-1.7a9.534,9.534,0,0,1-1.18-5.35,9.773,9.773,0,0,1,1.2-5.42q1.2-1.77,4.26-1.77t4.27,1.76A9.768,9.768,0,0,1,83.32-6.82Zm1.48-5.64v-1.38h10v1.38H90.58V0H89.06V-12.46ZM97.26,0V-13.84h8.42v1.36H98.8V-7.7h5.68v1.34H98.8v5h6.88V0Zm19.18,0h-7.62V-13.84h1.54V-1.38h6.08Z",
    transform: "translate(46 26)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRookLogo);
export default __webpack_public_path__ + "static/media/rook-logo.1b96a585f1f9a357043c566730d3f5e6.svg";
export { ForwardRef as ReactComponent };